export { useAuth } from "@/context/AuthContext";
export type { User } from "@/context/AuthContext";
